var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:_vm.classes,attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"change":_vm.valueChanged}},[(_vm.placeholder)?_c('option',{attrs:{"disabled":""},domProps:{"value":undefined}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dcacbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/singleselect.vue
// module id = 213
// module chunks = 41